import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';

export class ResizableText extends PureComponent {
  static propTypes = {
    containerHeight: PropTypes.number,
    children: PropTypes.element,
  };

  static defaultProps = {
    containerHeight: 140,
  };

  componentDidMount() {
    this.resize();
    /* istanbul ignore next */
    window.addEventListener('resize', this.resizeEventHandler, false);
  }

  /* istanbul ignore next */
  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeEventHandler, false);
  }

  getCSSValue = (el, property) =>
    parseInt(
      window
        .getComputedStyle(el)
        .getPropertyValue(property)
        .match(/\d+/)[0],
      10,
    );

  get textEl() {
    return document.querySelector(`#${React.Children.only(this.props.children).props.id}`);
  }

  resizeEventHandler = /* istanbul ignore next */ () => this.debouncedResize();

  debouncedResize = debounce(this.resize, 200, { leading: true });

  resize(width = 0) {
    const height = this.getCSSValue(this.textEl, 'height');
    const currWidth = this.getCSSValue(this.textEl, 'width');
    const currFontSize = this.getCSSValue(this.textEl, 'font-size');

    if (height > this.props.containerHeight) {
      this.textEl.style.fontSize = `${currFontSize - 2}px`;
      return this.resize(currWidth);
    }
    if (width < currWidth) {
      this.textEl.style.fontSize = `${Math.min(currFontSize + 5, 48)}px`;
      return this.resize(currWidth);
    }

    return false;
  }

  render() {
    return React.Children.only(this.props.children);
  }
}
